import { inject } from "fw";
import { Store, handle } from "fw-state";
import { LogoutAction, StartAction } from "./actions";
import { PlatformBackupInfo } from "models/platform";
import { PlatformRepository } from "network/platform-repository";

interface BackupsShape {
    currentUserId: string;
    loaded: boolean;
    errorLoading: boolean;
    list: PlatformBackupInfo[];
    selectedHistory: string;
    histories: any;
}

export class FetchListAction {}
export class BackupsRefreshAction {}
export class SetSelectedHistoryAction {
    constructor(public value: string = null) {}
}

@inject
export class BackupsStore extends Store<BackupsShape> {
    constructor(private network: PlatformRepository) {
        super();
    }

    defaultState() {
        return {
            currentUserId: null,
            loaded: false,
            errorLoading: false,
            list: [],
            selectedHistory: null,
            histories: []
        };
    }

    @handle(StartAction)
    private handleStartAction(action: StartAction) {
        this.setState(() => ({
            ...this.defaultState(),
            currentUserId: action.user.Id
        }));
    }

    @handle(SetSelectedHistoryAction)
    private handleSetHistoryAction(action: SetSelectedHistoryAction) {
        this.setState(() => ({
            histories: this.state.histories,
            list: this.state.list,
            currentUserId: this.state.currentUserId,
            loaded: false,
            errorLoading: false,
            selectedHistory: action.value
        }));

        this.loadPageData();
    }

    @handle(LogoutAction)
    private handleLogoutAction() {
        this.setState(() => this.defaultState());
    }

    @handle(BackupsRefreshAction)
    private handleRefreshAction(action: BackupsRefreshAction) {
        if (!this.state.loaded) return;

        this.setState((state) => ({
            ...state,
            loaded: false
        }));

        this.loadPageData();
    }

    @handle(FetchListAction)
    private handleFetchList() {
        this.setState(() => ({
            histories: this.state.histories,
            list: this.state.list,
            selectedHistory: this.state.selectedHistory,
            currentUserId: this.state.currentUserId,
            loaded: false,
            errorLoading: false
        }));

        this.loadPageData();
    }

    private async loadPageData() {
        try {
            const response = await this.network.backups();
            const selectedHistory = this.state.selectedHistory;
            const selectedHistoryList = selectedHistory ? response.Histories.find((i) => i.Name === selectedHistory) : response.Histories[0];

            if (response) {
                this.setState(() => ({
                    ...this.state,
                    list: selectedHistoryList.Backups,
                    loaded: true,
                    errorLoading: false,
                    histories: response.Histories.map((h) => h.Name),
                    selectedHistory: this.state.selectedHistory || selectedHistoryList.Name
                }));
            }
        } catch (err) {
            this.setState((state) => ({ ...state, loaded: true, errorLoading: true }));
        }
    }
}
